import React from 'react';
import { Guardian } from '@xaamin/guardian';
import { Route } from 'react-router-dom';
import PageError403 from '../shared/errors/PageError403';

const GuardianRoute = ({ component: Component, can, ...rest }) => (
  <Route {...rest} render={(props) => (
    Guardian.allows(can)
      ? <Component {...props} />
      : <PageError403 />
  )} />
)

export default GuardianRoute;